export let ILoqateFindResultType = /*#__PURE__*/function (ILoqateFindResultType) {
  ILoqateFindResultType["Locality"] = "Locality";
  ILoqateFindResultType["Address"] = "Address";
  ILoqateFindResultType["Street"] = "Street";
  ILoqateFindResultType["ManualEnter"] = "ManualEnter";
  return ILoqateFindResultType;
}({});
export let DeliveryError = /*#__PURE__*/function (DeliveryError) {
  DeliveryError["zipStateMismatch"] = "zipStateMismatch";
  return DeliveryError;
}({});